export const toDate = (value: any) => {
	if (!value)
		return new Date('Invalid')

	if (value instanceof Date)
		return value

	return new Date(isFinite(value) ? parseFloat(value) : value)
}